import React, { useRef } from "react"
import { useBoolean } from "../../../hooks/useBoolean"
import { useClickOutside } from "../../../hooks/useClickOutside"
import type { DropdownProps } from "./dropdown.interfaces"
import {
  DropdownWrapper,
  DropdownButton,
  DropdownList,
  DropdownItem
} from "./dropdown.styled"

const Dropdown: React.FC<DropdownProps> = React.memo(
  ({
    list,
    onChange,
    value,
    emptyText,
    label,
    customstyles,
    roomStyles,
    сolorBorder
  }) => {
    const [isOpen, { off, toggle }] = useBoolean(false)
    const containerRef = useRef<HTMLDivElement>(null)

    useClickOutside(containerRef, off)

    return (
      <DropdownWrapper style={customstyles?.wrapper || {}} ref={containerRef}>
        <DropdownButton
          style={customstyles?.button || {}}
          isOpen={isOpen}
          onClick={toggle}
          roomStyles={roomStyles}
          сolorBorder={сolorBorder}
          type="button"
        >
          {label || value.label}
        </DropdownButton>
        {isOpen && (
          <DropdownList
            style={customstyles?.list || {}}
            roomStyles={roomStyles}
          >
            {list.length > 0 ? (
              list.map(item => (
                <DropdownItem
                  key={item.id}
                  roomStyles={roomStyles}
                  style={customstyles?.item || {}}
                  onClick={() => {
                    onChange(item)
                    off()
                  }}
                >
                  {item.label}
                </DropdownItem>
              ))
            ) : (
              <DropdownItem
                style={customstyles?.emtyItems || {}}
                roomStyles={roomStyles}
              >
                {emptyText}
              </DropdownItem>
            )}
          </DropdownList>
        )}
      </DropdownWrapper>
    )
  }
)

export default Dropdown
